// extracted by mini-css-extract-plugin
module.exports = {"host":"BaseInputPassword_host__3qPsC","label":"BaseInputPassword_label__25tco"};